export enum ClientListActionTypes {
  Init = '[ClientList Page] Init',
  ListViewTypeChanged = '[ClientList Page] List View Type Changed',
  FiltersChanged = '[ClientList Page] Filters Changed',
  ViewMoreClicked = '[ClientList Page] View More Clicked',
}

export enum ClientActionTypes {
  Init = '[Client Page] Init',
  ClientSelected = '[Client Page] Client Selected',
  Destroyed = '[Client Page] Destroyed',
}

export enum ClientNewActionTypes {
  Init = '[ClientNew Page] Init',
  ClientDataAdded = '[ClientNew Page] Client Data Added',
  StepClicked = '[ClientNew Page] Step Clicked',
  NextStepClicked = '[ClientNew Page] Next Step Clicked',
  StepsChanged = '[ClientNew Page] StepsChanged',
}

export enum ClientSubClientNewActionTypes {
  ClientAdded = '[ClientSubClientNew Page] Client Added',
}

export enum ClientUpdateActionTypes {
  ClientUpdated = '[ClientUpdate Page] Client Updated',
}

export enum ClientPoliciesActionTypes {
  Init = '[ClientPolcies Page] Init',
  ListViewTypeChanged = '[ClientPolcies Page] List View Type Changed',
  ViewMoreClicked = '[ClientPolcies Page] View More Clicked',
  FiltersChanged = '[ClientPolcies Page] Filters Changed',
}

export enum ClientDocumentsActionTypes {
  Init = '[ClientDocuments Page] Init',
  FolderCreated = '[ClientDocuments Page] Folder Created]',
  DocumentDownloaded = '[ClientDocuments Page] Document Downloaded',
  DocumentMoved = '[ClientDocuments Page] Document Moved',
  DocumentUpdated = '[ClientDocuments Page] Document Updated',
  DocumentDeleted = '[Documents Page] Document Deleted',
  FolderUpdated = '[ClientDocuments Page] Folder Updated',
  FolderDeleted = '[ClientDocuments Page] Folder Deleted',
  UploadDocumentsClicked = '[ClientDocuments Page] Upload Documents Clicked',
  FilesDropped = '[ClientDocuments Page] Files Dropped',
  ListViewTypeChanged = '[ClientDocuments Page] List View Type Changed',
  FiltersChanged = '[ClientDocuments Page] Filters Changed',
  Destroyed = '[ClientDocuments Page] Destroyed',
}

export enum ClientDocumentsEffectsActionTypes {
  Navigated = '[ClientDocuments Effects] navigated',
}

export enum ClientBrokersActionTypes {
  Init = '[ClientBrokers Page] Init',
  Destroyed = '[ClientBrokers Page] Destroyed',
}

export enum ClientContactsActionTypes {
  Init = '[ClientContacts Page] Init',
  ContactSelected = '[ClientContacts Page] Contact Selected',
  DetailsPanelClosed = '[ClientContacts Page] Details Panel Closed',
  ListViewTypeChanged = '[ClientContacts Page] List View Type Changed',

  ContactEnabled = '[ClientContacts Page] Contact Enabled',
  ContactDisabled = '[ClientContacts Page] Contact Disabled',

  ViewMoreClicked = '[ClientContacts Page] View More Clicked',
  Destroyed = '[ClientContacts Page] Destroyed',
}

export enum ClientContactsCreateActionTypes {
  AddContact = '[ClientCreate Page] Add Contact',
  AddContactSuccess = '[ClientCreate/API] Add Contact Success',
  AddContactFailure = '[ClientCreate/API] Add Contact Failure',
}
